import { render, staticRenderFns } from "./affiliate-footer-bar.vue?vue&type=template&id=3a25db9a&scoped=true&"
import script from "./affiliate-footer-bar.vue?vue&type=script&lang=ts&"
export * from "./affiliate-footer-bar.vue?vue&type=script&lang=ts&"
import style0 from "./affiliate-footer-bar.vue?vue&type=style&index=0&id=3a25db9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a25db9a",
  null
  
)

export default component.exports